module.exports = __webpack_public_path__ + "img/makeup.eeea56ec.svg";